import { render } from "./festival.vue?vue&type=template&id=486f7d00"
import script from "./festival.vue?vue&type=script&lang=js"
export * from "./festival.vue?vue&type=script&lang=js"

import "./festival.vue?vue&type=style&index=0&id=486f7d00&lang=css"

import exportComponent from "/Users/aun/Development/thailand-fest/thai-festival-admin-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__